/*!
 * Copyright © 2023. Verizon Connect Ireland Limited. All rights reserved.
 */

import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IGeofenceState } from './geofence.state';

export const getGeofenceState = createFeatureSelector<IGeofenceState>('geofence');

export const getGeofenceLatLng = createSelector(getGeofenceState, (state: IGeofenceState) => state.geofenceLatLng);

export const getGeofenceAddress = createSelector(getGeofenceState, (state: IGeofenceState) => state.geofenceAddress);

export const getIsGeofenceCreateOpen = createSelector(getGeofenceState, (state: IGeofenceState) => state.geofenceCreateOpen);

export const getGeofenceDrawingControlShape = createSelector(getGeofenceState, (state: IGeofenceState) => state.drawingControlShape);

export const getGeofenceDrawingControlClearPressed = createSelector(
  getGeofenceState,
  (state: IGeofenceState) => state.drawingControlClearPressed
);

export const getGeofenceCurrentShape = createSelector(getGeofenceState, (state: IGeofenceState) => state.currentShape);

export const getPlaceDropdownCategories = createSelector(getGeofenceState, (state: IGeofenceState) => state.placeDropdownCategories);

export const getPlaceBalloon = createSelector(getGeofenceState, (state: IGeofenceState) => state.placeLoaded);
